import { FC } from 'react'
import { Capacitor } from '@capacitor/core'

import { Button as MerinioButton } from 'ui'

import styles from '../../styles.module.scss'

type Props = {
  chatOpen: boolean
  setChatOpen: (chatOpen: boolean) => void
  children: React.ReactNode
}

const ChatModal: FC<Props> = ({ chatOpen, children, setChatOpen }) => {
  if (!chatOpen) return null

  return (
    <div className={`${styles.container} ${Capacitor.isNativePlatform() && styles.merinioChatSafeArea}`}>
      <div className="p-2">
        <MerinioButton type="button" className="close d-block d-sm-none" aria-label="Close" onClick={() => setChatOpen(false)}>
          <span aria-hidden="true">&times;</span>
        </MerinioButton>
      </div>
      <div className={styles.chatModal}>{children}</div>
    </div>
  )
}

export { ChatModal }
